import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  group: {
    base: {
      paddingBottom: theme.settings.spacing.small,
    },

    flush: {
      paddingBottom: 0,
    },
  },
})
